<template>
  <div class="home">
    <section class="cover">
      <nav>
        <span class="logo">
          Fast Furniture
        </span>
        <span class="logo">
          <img width="144px" src="../../assets/vme.jpg">
        </span>
        <ul>
          <li v-if="$msal.isAuthenticated()">
            <router-link class="white" to="suppliers">Supplier</router-link>
          </li>
          <li v-if="!$msal.isAuthenticated()" class="ghost-btn">
            <router-link class="white" to="login">Login</router-link>
          </li>
          <li v-if="$msal.isAuthenticated()" class="ghost-btn">
            <a class="white" @click="$msal.signOut()">Logout</a>
          </li>
        </ul>
      </nav>
      <div class="content">
        <h2 class="heading">Modellsuche<br />jetzt starten.</h2>
        <div class="cta-btn p-button-lg">
          <router-link class="white" to="login">Login</router-link>
        </div>
        <!-- <p class="highlight">30 day trial | No Bandwidth limit</p> -->
      </div>
    </section>

    <!--<div v-if="user">
      <div>Welcome {{ user.name }}</div>
      <div v-if="user.profile.jobTitle">
        Your job title is {{ user.profile.jobTitle }}
      </div>
      <div><button @click="$msal.signOut()">logout</button></div>
    </div>
    <div v-else>
      Please sign-in
      <button @click="$msal.signIn()"></button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {};
  },
  created() {
    if (this.$msal.isAuthenticated()) {
      if (this.isShareholder()) {
        this.$router.push("/suppliers");
      }else if (this.isAdmin()){
        this.$router.push("/manage/suppliers");
      }
    }
  },

  // computed: {
  //   user() {
  //     let user = null;
  //     if (this.msal.isAuthenticated) {
  //       // Note that the dollar sign ($) is missing from this.msal
  //       user = {
  //         ...this.msal.user,
  //         profile: {}
  //       };
  //       if (this.msal.graph && this.msal.graph.profile) {
  //         user.profile = this.msal.graph.profile;
  //       }
  //     }
  //     return user;
  //   }
  // },
  methods: {}
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  background: #515151;
}
section.cover {
  background: linear-gradient(45deg, #EE7F00 50%, #f18209 50%);
  padding: 20px 10%;
  border-bottom: 50px solid transparent;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  min-height: 500px;
}
section nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.4rem;
  color: #fff;
}
section nav ul {
  list-style-type: none;
  font-size: 0.8rem;
}
section nav ul li {
  float: left;
  padding: 10px;
}
.ghost-btn {
  margin: 0 10px;
  padding: 10px;
  border: 1px solid #fff;
  border-radius: 5px;
}
div.cta-btn {
  margin: 40px 0 20px 0;
}
div.cta-btn a {
  padding: 10px 20px;
  background-color: #525252;
  text-decoration: none;
  color: #fff;
  border-radius: 5px;
  font-size: 1.5em;
}
section.cover .content .heading {
  font-size: 2.5rem;
  font-weight: 500;
}
section.cover .content {
  color: #fff;
  padding: 40px 0;
  position: relative;
  text-align: center;
}
section.cover .content .highlight {
  font-size: 10px;
}
section.cover .content .card {
  position: absolute;
  bottom: 10px;
  right: 0;
  width: 140px;
  padding: 20px 40px;
  background-color: #fff;
  color: #888;
  border-radius: 5px;
  transition: 200ms all ease-in-out;
  cursor: pointer;
}
section.cover .content .card:hover {
  transform: translateY(-5px);
  color: #222;
}

.white {
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/Home.vue